// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {

  production: false,
  region: 'us-east-1',
  identityPoolId: 'us-east-1:4d278469-ab1a-4b2e-87c9-4e3f68fab5cb',
  userPoolId: 'us-east-1_CNz94m1ZJ',
  clientId: '7j3r8qre4i1p05s1igoadko8h2',
  rekognitionBucket: 'rekognition-pics',
  mandatorySignIn: true,
  albumName: 'usercontent',
  bucketRegion: 'us-east-1',
  accountId: '153888508172',

  ddbTableName: 'LoginTrail',

  cognito_idp_endpoint: '',
  cognito_identity_endpoint: '',
  sts_endpoint: '',
  dynamodb_endpoint: '',
  s3_endpoint: '',
  gaPropertyId:'UA-177963797-11',
  gtmContainerId:'GTM-NWVZQ7Z',

  webSocket: 'wss://www.iposcentral-uat.com/web-profiles',
  deviceReportWebSocket: 'wss://www.iposcentral-uat.com/web-devices',
  deviceDashboardWebSocket: 'wss://www.iposcentral-uat.com/web-device-dashboard',
  stdPkgWebSocketURL: 'wss://www.iposcentral-uat.com/web-packagehandler',//IIT2-5802
  apiBaseUrl: 'https://www.iposcentral-uat.com',
  apiBaseUrlAsset: 'https://www.iposcentral-uat.com/asset-library-uat-original',
  uwpDefaultPackage: 'https://www.microsoft.com/store/apps/9NBQV3MMHXL0',
  pollFrequency: 20,
  gamingPollFrequency: 20,
  hidePartnerContent : false //Falg to show / hide partner content
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
